import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpErrorResponse, HttpEventType} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { HssResponse } from './HssResponse';
import { HssErrorResponse } from './HssErrorResponse';

@Injectable({
  providedIn: 'root'
})
/**
 * Project : HSS-Online
 * @class ApiService
 */
export class ApiService {
  constructor(private httpClient: HttpClient) {}

  private requestCall(
    methodType: string,
    url: string,
    option: any,
    body?: any
  ): Observable<any> {
    option = this.calibrateReqHeaders(option, body, url.includes('login'));

    const makeObs = (fullUrl: string) => {
      return this.httpClient.request(methodType, fullUrl, option).pipe(
        catchError(err => this.handleError(err)),
        map((res: any) => {
          return this.selectResponse(res);
        })
      );
    };

    return makeObs(environment.serviceEndPoint + url);
  }

  private selectResponse(response: any): HssResponse<any> {
    const returnObject = new HssResponse();

    returnObject.isSuccess = true;
    returnObject.message = response.body.message;
    returnObject.body = response.body.data;

    return returnObject;
  }

  private calibrateReqHeaders(
    option: any | null,
    body?: any,
    isAuthentication?: boolean
  ) {
    const jwtToken: string = 'Bearer ' + localStorage.getItem('userToken');

    if (option == null) {
      option = {};
    }
    if (!option.responseType) {
      option.responseType = 'json';
    }
    option.observe = 'response';

    if (!!body) {
      option.body = body;
    }

    if (option.headers == null) {
      option.headers = new HttpHeaders();
    }

    option.headers = option.headers.set('Content-Type', 'application/json');

    if (!!jwtToken && !isAuthentication) {
      // @ts-ignore
      option.headers = option.headers.set('Authorization', jwtToken);
    }
    return option;
  }

  // Handle API errors
  private handleError(error: HttpErrorResponse): Observable<never> {
    const errorResponse = new HssErrorResponse();
    errorResponse.isSuccess = false;
    errorResponse.errorCode = error.status;
    errorResponse.message = error.statusText;

    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.warn('An error occurred:', error.error.message);
      errorResponse.errorCode = -1;
      errorResponse.message = error.message;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.warn('An error occurred:', error.error);

      if (error.error.message) {
        errorResponse.message = error.error.message;
      }

      if (error.error.error) {
        errorResponse.message = error.error.error;
      }
      errorResponse.errorCode = error.status;
    }

    // TO DO : Logout function if session expired

    // return an observable with a user-facing error message
    return throwError(errorResponse);
  }

  get(route: string, option?: any): Observable<any> {
    return this.requestCall('GET', route, option);
  }

  post(route: string, option?: any, body?: any): Observable<any> {
    return this.requestCall('POST', route, option, body);
  }

  put(route: string, option?: any, body?: any): Observable<any> {
    return this.requestCall('PUT', route, option, body);
  }

  delete(route: string, option?: any, body?: any): Observable<any> {
    return this.requestCall('DELETE', route, option, body);
  }

  upload(url: string, formData: any) {
    const jwtToken: string = 'Bearer ' + localStorage.getItem('userToken');

    const option: any = {
      responseType: 'json',
      reportProgress: true,
      observe: 'events'
    };

    option.headers = new HttpHeaders();
    option.headers = option.headers.set('Authorization', jwtToken);

    return this.httpClient
      .post<any>(environment.serviceEndPoint + url, formData, option)
      .pipe(
        catchError(err => this.handleError(err)),
        map((res: any) => {
          if (res.type === HttpEventType.Response)
            return this.selectResponse(res);

          return res;
        })
      );
  }
}
//   register(params: object, success, error, fail) {
//     const url = this.baseURL + '/register';
//     return this.httpClient.makePostRequest(url, params, success, error, fail);
//   }
//
// }
